import { render, staticRenderFns } from "./widgetSysVlanTraffic.vue?vue&type=template&id=607996fb&scoped=true&"
import script from "./widgetSysVlanTraffic.vue?vue&type=script&lang=js&"
export * from "./widgetSysVlanTraffic.vue?vue&type=script&lang=js&"
import style0 from "./widgetSysVlanTraffic.vue?vue&type=style&index=0&id=607996fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607996fb",
  null
  
)

export default component.exports